<template>
  <div>
   <!-- Page Title-->
    <div class="page-title">
      <div class="container">
        <h1>Complete</h1>
        <ul class="breadcrumbs">
          <li><router-link to="/home">Home</router-link>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li>Complete</li>
        </ul>
      </div>
    </div>
    <!-- Page Content-->
    <div class="container padding-bottom-3x mb-2">
      <div class="card text-center border-default">
        <div class="card-body padding-top-2x">
          <h3 class="card-title mb-4"> <strong>Nous vous remercions de votre commande!</strong></h3>
          <p class="text-sm mb-2"><strong>Votre commande a été passée et sera traitée dès que possible.</strong></p>
          <p class="text-sm mb-2"><strong>Assurez-vous de noter votre numéro de commande,soit</strong>
            <span class="text-medium">{{order}}</span></p>
          <p class="text-sm mb-2"><strong>Vous recevrez un email sous peu avec la confirmation de votre commande.</strong>
          </p>
          <div class="padding-top-1x padding-bottom-1x">
            <router-link to="/all"><a class="btn btn-outline-secondary"><strong>Accuiel</strong></a></router-link>
            <!--<a class="btn btn-outline-primary" href="order-tracking.html">
              <i class="material-icons my_location"></i>&nbsp;Track order</a>
              -->
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({ order: 'orderId'})
  }
};
</script>

<style scoped>
.page-title {
  margin-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/checkout/complete.vue